export default __webpack_public_path__ + "static/media/QuestIndicator.3d84f591.svg";